"use client";

import dynamic from "next/dynamic";
import type { HeroTranslateMediaClientDemoProps } from "./HeroTranslateMediaClientDemo";

const HeroTranslateMediaClientDemo = dynamic(() => import("./HeroTranslateMediaClientDemo").then(mod => mod.default));

export default function HeroTranslateMediaLazy(props: HeroTranslateMediaClientDemoProps) {
  return <HeroTranslateMediaClientDemo {...props} />;
}
